const methods = ({ request }) => ({

  getAdminData: async () => 
    request(`AdminData`),

  getPromoCode: async promoCode =>
    request(`User/Subscribe/PromoCodes/${promoCode}`),

  postSubscription: body =>
    request('User/Subscribe', { method: 'POST', body }),

  subscribeViaFooter: body =>
    request('User/SubscribeViaFooter', { method: 'POST', body }),
});

export default methods;



// WEBPACK FOOTER //
// ./src/lib/api/subscribe.js